module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_SE-0f083b697e258d79ab6439e6f3388007.svg";